import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		isLoggedIn: !!localStorage.getItem("token"),
		userRole: localStorage.getItem('userRole'),
		mainRole: localStorage.getItem('mainRole'),
		loginType: localStorage.getItem('loginType'),
		activeSection:localStorage.getItem('activeSection'),
		userName: localStorage.getItem('userName'),
		minister: localStorage.getItem('minister') || "no",
		userData: {},
		counterData: {},
		notification: 0,
		authentication: false,

		// appLoading: false
	},
	mutations: {
		loginUser(state, item) {
			localStorage.setItem("token", item)
			state.isLoggedIn = item
			// if (state.userRole == 'admin') router.push('/admin')
			// else if (state.userRole == 'official') router.push('/officers')
		},

		logoutUser(state) {
			
			axios({
				method: "GET",
				url: "/user/logout",
				headers: {
					"x-auth-token": localStorage.getItem("token")
				}
			}).then(response => {
				if (response.data) {
					state.userData = {}
					state.userRole = null
					state.isLoggedIn = false
					state.notification = 0
					localStorage.removeItem("token");
					localStorage.removeItem("userRole");
					localStorage.removeItem("userName");
					localStorage.removeItem("mainRole");
					localStorage.removeItem("loginType");
					localStorage.removeItem("activeSection");
					localStorage.removeItem("userType");
					localStorage.removeItem("division");
					localStorage.removeItem("minister");
					// localStorage.removeItem("currentPage");

					Object.keys(localStorage).forEach(key => {
						if (key.endsWith('_currentPage')) {
						localStorage.removeItem(key);
						}
					});

					const isPublicRoute = ['/', '/login', '/privacy-policy', '/support', '/login', '/', '/delete-account'].includes(window.location.pathname);
					if (!isPublicRoute) {
						router.push('/login')
					}
				}
			})

			

		},
		userData(state, item) {
			state.userData = item
		},
		counterData(state, item) {
			state.counterData = item
		},
		changeNotification(state, item) {
			state.notification = item
		},
		authValue(state, item) {
			state.authentication = item
		},

		userRole(state, item) {
			state.userRole = item
			localStorage.setItem("userRole", item);
		},
		mainRole(state, item) {
			state.mainRole = item
			localStorage.setItem("mainRole", item);
		},
		loginType(state, item) {
			state.loginType = item
			localStorage.setItem("loginType", item);
		},
		userName(state, item) {
			state.userName = item
			localStorage.setItem("userName", item);
		},
		minister(state, item) {
			state.minister = item
			localStorage.setItem("minister", item);
		},
		sessionOut(state) {
			localStorage.removeItem("token");
			localStorage.removeItem("minister");
			state.isLoggedIn = false
			router.push('/Login')

		}
		
	}

})
